<template>
  <div class="home-page">
    <div class="page-card">
      <h1>智能康复医学教学平台</h1>
      <div class="divider"></div>

      <h2>平台简介</h2>
      <p>本平台为口腔癌术后康复专项AI教学实训系统，面向康复治疗专业学生，依托大语言模型实现标准化虚拟病例、苏格拉底式问答教学、分阶段课程学习，用于口腔癌围手术期康复理论与实操能力培训。</p>

      <h2>教学目的</h2>
      <ul>
        <li>掌握口腔癌（舌癌）围手术期完整康复理论知识，熟悉手术方式、急性期‑亚急性期‑居家全周期康复要点</li>
        <li>借助虚拟标准化病人，训练吞咽、张口受限、语音障碍等功能障碍评估与康复方案制定能力</li>
        <li>对比传统讲义教学与LLM交互式教学的学习效果，完成RCT教学研究数据采集</li>
      </ul>

      <h2>项目伦理说明</h2>
      <div class="ethic-box">
        ✅本教学研究项目已通过伦理委员会审批，所有受试者信息严格脱敏；采集的问卷、操作日志仅用于科研统计，不会对外泄露个人信息。
      </div>

      <!-- 动态入口：根据完成状态显示 -->
      <div class="survey-entry">
        <h2>科研问卷调查</h2>
        <div v-if="!isPreTestFinished" class="entry-item">
          <p>请先完成学习前基线测评问卷</p>
          <el-button type="primary" @click="$router.push('/survey/pre-test')">进入前测问卷</el-button>
        </div>
        <div v-else-if="!isCourseFinished" class="entry-item">
          <p>请完成所有课程学习后，再进行后测测评</p>
          <el-button type="primary" disabled>后测问卷（未解锁）</el-button>
        </div>
        <div v-else class="entry-item">
          <p>{{ isPostTestFinished ? "✅你已经完成后测问卷" : "你已完成所有课程学习，请完成学习效果后测问卷" }}</p>
          <el-button
              type="success"
              :disabled="isPostTestFinished"
              @click="$router.push('/survey/post-test')"
          >
            {{ isPostTestFinished ? "已完成后测问卷" : "进入后测问卷" }}
          </el-button>
        </div>
      </div>

      <div class="tip-text">
        <p>💡提示：左侧菜单栏可以进入课程学习、虚拟病人交互模块。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  // ✅删掉data里面三个布尔变量，删掉created生命周期
  computed: {
    isPreTestFinished() {
      return this.$store.state.user.preTestFinished
    },
    isCourseFinished() {
      return this.$store.state.user.courseFinished
    },
    isPostTestFinished() {
      return this.$store.state.user.postTestFinished
    }
  }
}
</script>

<style scoped>
.home-page{
  padding:24px;
}
.page-card{
  max-width:900px;
  background:#fff;
  padding:32px;
  border-radius:8px;
}
.divider{
  height:2px;
  background:#eee;
  margin:16px 0 24px;
}
h1{
  font-size:28px;
  color:#2c3e50;
}
h2{
  font-size:20px;
  margin:24px 0 12px;
  color:#34495e;
}
p{
  line-height:1.75;
  font-size:15px;
  color:#444;
}
ul{
  line-height:1.8;
  padding-left:20px;
}
.ethic-box{
  background:#ecf5ff;
  border:1px solid #b3d8ff;
  padding:12px 16px;
  border-radius:6px;
  margin:8px 0;
  color:#0052cc;
}
.tip-text{
  margin-top:30px;
  padding-top:16px;
  border-top:1px solid #eee;
  color:#666;
}
.survey-entry {
  margin-top: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
}
.entry-item {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}
</style>